// components/InterstitialAd.tsx
import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'

declare global { interface Window { googletag: any } }

const AD_UNIT_PATH = '/21830119956,10216148/opopular.com.br/AL_0214n_INTERSTICIAL_DESK'
const SECTIONS = ['esporte', 'economia', 'magazine']

let bannerSlot: null = null

const InterstitialAd: React.FC = () => {
  const { asPath } = useRouter()
  const prevIsSection = useRef(false)


  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] }
    window.googletag.cmd.push(() => {
      bannerSlot = window.googletag
        .defineSlot(
          AD_UNIT_PATH,
          [[336, 280], [300, 250], [320, 480]],
          'static-ad-1'
        )
        .addService(window.googletag.pubads())

      window.googletag.pubads().enableSingleRequest()
      window.googletag.enableServices()
      window.googletag.display('static-ad-1')
    })
  }, [])

  useEffect(() => {
    const isSection = SECTIONS.some(sec =>
      asPath === `/${sec}` || asPath.startsWith(`/${sec}/`)
    )

    if (isSection && !prevIsSection.current && bannerSlot) {
      window.googletag.cmd.push(() => {
        window.googletag.pubads().refresh([bannerSlot!])
      })
    }

    prevIsSection.current = isSection
  }, [asPath])

  return (
    // Esse DIV precisa existir no seu HTML / JSX
    <div id="static-ad-1" style={{ width: '100%', height: 'auto' }} />
  )
}

export default InterstitialAd
